module.exports = __webpack_public_path__ + "img/baseball.ac3b4743.svg";